
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class TagPreview extends Vue {
	@Prop({ type: Object, required: true }) private tag!: MenuItemTag;
	@Prop({ type: Boolean, default: false }) private iconOnly!: boolean;
}
